/**
 * Insurance Agencies Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageWhatsAppDevicesComponent,
  AsyncAddWhatsAppDeviceComponent,
  AsyncModifyWhatsAppDeviceComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageWhatsAppDevicesComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
